import type { Post } from "@apps/gwservice/types"
import { AddablePostList } from "./addable-post-list"
import { InfinitePostList } from "~/components/infinite-post-list"
import { getPostsByTopic } from "../server/topic.functions"

interface Props {
  topicId: number
  allowAdd?: boolean
  initialItems: Post[]
  initialNextPage?: number
}

export function PostsFeed({ topicId, allowAdd, initialItems, initialNextPage }: Props) {
  if (!allowAdd) {
    return (
      <InfinitePostList
        initialItems={initialItems}
        initialNextPage={initialNextPage}
        loadMore={(page) => getPostsByTopic({ data: { topicId, page } })}
      />
    )
  }

  return (
    <AddablePostList
      topicId={topicId}
      initialItems={initialItems}
      initialNextPage={initialNextPage}
      loadMore={(page) => getPostsByTopic({ data: { topicId, page } })}
    />
  )
}
